import { Box, Grid2, Tab, Tabs } from "@mui/material";
import { useState } from "react";
import { Center } from "@mantine/core";
import TabPanel from "@mui/lab/TabPanel";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import { ClientDetailsPanel } from "./components/client-detailsPanel";
import { ClientCareInfoPanel } from "./components/client-careInfoPanel";
import { ClientMedicalInfoPanel } from "./components/client-medicalInfoPanel";
import { ClientContactPanel } from "./components/client-contactPanel";
import { ClientFileUploadPanel } from "./components/client-filePanel";
import { ClientLogPanel } from "./components/client-logPanel";
import { ClientFormPanel } from "./components/client-formPanel";


export const ClientView = () => {

    const [value, setValue] = useState("1");
    const handleChange = (event: React.SyntheticEvent, newValue: string) => {
        setValue(newValue);
    };

    return (
        <>
            <Grid2 container spacing={1} p={2}>
                <Grid2 size={{ xs: 12, sm: 4, md: 2.5 }} mt={4.8}>
                    <ClientDetailsPanel />
                </Grid2>
                <Grid2 size={{ xs: 12, sm: 4, md: 2.5 }} mt={4.8}>
                    <ClientCareInfoPanel />
                    <ClientMedicalInfoPanel />


                </Grid2>

                <Grid2 size={{ xs: 12, sm: 8, md: 7 }}>
                    <TabContext value={value}>
                        <Grid2 size={{ xs: 12 }} sx={{ display: "flex", justifyContent: "left" }}>

                            <TabList onChange={handleChange} variant="fullWidth" sx={{

                                backgroundColor: "grey.100",
                                borderRadius: 1,
                                minHeight: 48,
                                "& .MuiTabs-indicator": {
                                    display: "none",
                                },
                                "& .MuiTab-root": {
                                    flex: 1,
                                    minHeight: "48px",
                                    fontWeight: 500,
                                    borderRadius: 1,
                                    "&.Mui-selected": {
                                        backgroundColor: "primary.main",
                                        color: "white",
                                    },
                                },
                            }}>

                                <Tab label="Client Contacts" value="1" />
                                <Tab label="Forms" value="2" />
                                <Tab label="Logs" value="3" />
                                <Tab label="Files" value="4" />

                            </TabList>

                        </Grid2>
                        <TabPanel value="1" sx={{ p: 0, mt: 0.55 }} >
                            <Grid2 container spacing={1}>

                                <Grid2 size={{ xs: 12, sm: 6, md: 12 }}>
                                    <ClientContactPanel />

                                </Grid2>
                            </Grid2>
                        </TabPanel>
                        <TabPanel value="2" sx={{ p: 0, mt: 0.55 }} >
                            <Grid2 container spacing={1}>
                                <Grid2 size={{ xs: 12, sm: 6, md: 12 }}>
                                    <ClientFormPanel />
                                </Grid2>
                            </Grid2>
                        </TabPanel>
                        <TabPanel value="3" sx={{ p: 0, mt: 0.55 }} >
                            <Grid2 container spacing={1}>

                                <Grid2 size={{ xs: 12, sm: 6, md: 12 }}>
                                    <ClientLogPanel />
                                </Grid2>
                            </Grid2>
                        </TabPanel>
                        <TabPanel value="4" sx={{ p: 0, mt: 0.55 }} >
                            <Grid2 container spacing={1}>
                                <Grid2 size={{ xs: 12, sm: 6, md: 12 }}>
                                    <ClientFileUploadPanel />
                                </Grid2>
                            </Grid2>
                        </TabPanel>
                    </TabContext >
                </Grid2>
            </Grid2>
        </>
    );
};